@import '../../../../scss/01_settings/variables.scss';

kwo-timeline {

  .event {
    &:not(:last-child) {
      min-height: 100vh;
      margin-bottom: var(--spacing-3xl);
    }
  }

  .year {
    font-size: clamp(2.5rem, 12vw, 10rem);
    font-weight: 600;
    pointer-events: none;
    padding-bottom: var(--spacing-md);
    top: var(--spacing-3xl);
    @media screen and (min-width: 768px) {
      top: calc(50vh  - 0.5em);
    }
    lg-num-slide {
      font-size: inherit;
      line-height: 0.8;
      @media screen and (min-width: 768px) {
        margin-top: -0.125em;
        line-height: 1;
      }
    }
  }

}
